import { Zap, Mail, Linkedin, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative bg-dark-950 border-t border-cyan-500/10 py-16">
      <div className="w-full px-6 lg:px-12 xl:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center">
                  <Zap className="w-5 h-5 text-dark-950" />
                </div>
                <span className="font-heading font-bold text-lg text-white">
                  Darkforce Digital
                </span>
              </div>
              <p className="text-dark-400 text-sm max-w-md mb-6">
                Full-service Amazon management powered by AI. We handle the complexity while you focus on growing your business.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 rounded-lg bg-dark-900 flex items-center justify-center text-dark-400 hover:text-cyan-400 hover:bg-dark-800 transition-all">
                  <Linkedin className="w-5 h-5" />
                </a>
                <a href="#" className="w-10 h-10 rounded-lg bg-dark-900 flex items-center justify-center text-dark-400 hover:text-cyan-400 hover:bg-dark-800 transition-all">
                  <Twitter className="w-5 h-5" />
                </a>
                <a href="mailto:hello@darkforcedigital.com" className="w-10 h-10 rounded-lg bg-dark-900 flex items-center justify-center text-dark-400 hover:text-cyan-400 hover:bg-dark-800 transition-all">
                  <Mail className="w-5 h-5" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4">Services</h4>
              <ul className="space-y-3">
                {['Campaign Management', 'Account Strategy', 'AI Intelligence', 'Performance Analytics'].map((item) => (
                  <li key={item}>
                    <a href="#services" className="text-dark-400 text-sm hover:text-cyan-400 transition-colors">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4">Company</h4>
              <ul className="space-y-3">
                {['Case Studies', 'Contact', 'Privacy Policy'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-dark-400 text-sm hover:text-cyan-400 transition-colors">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-cyan-500/10 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-dark-500 text-sm">
              © 2025 Darkforce Digital. All rights reserved.
            </p>
            <p className="text-dark-500 text-sm">
              Amazon growth management, powered by AI.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
